@import './pk-num-stat-item.variables';

:host {
  @apply block;
}

.num-stat-item {
  @apply flex items-center justify-between p-0 text-[color:--num-stat-color];
}

::slotted([slot='stat-value']),
::slotted([slot='stat-value-secondary']) {
  @apply mr-xs2 inline-flex;
  font-family: var(--num-stat-value-ff);
}

::slotted([slot='stat-value']) {
  @apply text-[length:--num-stat-value];
}

::slotted([slot='left-img']) {
  @apply mr-xs w-xl;
}

::slotted([slot='stat-value-secondary']) {
  @apply text-[length:--num-stat-value-secondary];
}

::slotted([slot='stat-label']) {
  @apply text-[length:--num-stat-label-size] leading-[--num-stat-label-line-height] text-[color:--num-stat-label-color];
  font-family: var(--num-stat-label-ff);
}

::slotted([slot='stat-second-label']) {
  @apply overflow-hidden text-ellipsis whitespace-nowrap text-[length:--num-stat-secondary-label-size] leading-[--num-stat-secondary-label-line-height] text-[color:--num-stat-secondary-label-color];
  font-family: var(--num-stat-label-ff);
}

.num-stat-item--secondary {
  ::slotted([slot='stat-value']) {
    @apply text-[length:--num-stat-value-secondary];
  }
}
